<template>
  <div class="w-100 existing-catalog">
    <label class="w-100 font-weight-bold">{{ $t("GenerateCatalogFromTextFile.ExistingCatalog") }} </label>
    <div class="d-flex">
      <b-dropdown class="dropdown-default grow mr-2">
        <template #button-content>
          <text-with-fallback-display :source="selectedSourceCatalog" :language="primaryLanguage" field="name"></text-with-fallback-display>
        </template>
        <b-dropdown-item
          :active="catalog[language].catalogId === selectedCatalogId ? true : false"
          v-for="catalog in sortedCatalogs"
          :key="catalog[language].catalogId"
          @click="selectCatalogId(catalog)">
          <text-with-fallback-display :source="catalog" :language="primaryLanguage" field="name"> </text-with-fallback-display>
        </b-dropdown-item>
      </b-dropdown>
      <b-btn class="btn-icon mono" v-b-modal.select-source-catalog>
        <i class="mdp-Open"></i>
      </b-btn>
    </div>

    <div class="catalog-modal-buttons">
      <b-btn
        class="mr-2"
        @click="
          $emit('stepChange', {
            currentState: 'ExistingCatalog',
            nextState: 'Intro'
          })
        "
        >{{ $t("Back") }}</b-btn
      >
      <b-btn @click="handleNext" :disabled="selectedCatalogId === null">{{ $t("Continue") }}</b-btn>
    </div>
    <manage-catalogs
      @selectedCatalog="(selectedSourceCatalogId) => (selectedCatalogId = selectedSourceCatalogId)"
      modal-name="select-source-catalog"
      :includedCatalogTypes="[0, 1]"
      dialogMode="open" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import TextWithFallbackDisplay from "../../../../../src/common/components/TextWithFallbackDisplay.vue";
import ManageCatalogs from "../../ManageCatalogs.vue";
import { naturalSort } from "@util/naturalSort";

export default {
  components: { TextWithFallbackDisplay, ManageCatalogs },

  props: ["selectedExistingCatalogId"],
  data() {
    return {
      selectedCatalogId: null,
      selectedCatalogName: null
    };
  },
  mounted() {
    this.selectedCatalogId = this.selectedExistingCatalogId;
  },
  computed: {
    ...mapState("metadata", ["contentLanguages"]),
    ...mapState("channelCreator", ["catalogs"]),
    ...mapGetters("channelCreator", {
      selectedTargetCatalog: "selectedTargetCatalog"
    }),

    primaryLanguage() {
      return this.contentLanguages?.enabled[0];
    },
    language() {
      return this.primaryLanguage?.languageCode;
    },
    sortedCatalogs() {
      return naturalSort(this.catalogs, (elem) => elem[this.language]?.name);
    },
    selectedSourceCatalog() {
      return this.catalogs.find((c) => c[this.language].catalogId === this.selectedCatalogId);
    }
  },
  methods: {
    handleNext() {
      this.$emit("update:selectedExistingCatalogId", this.selectedCatalogId);
      this.$emit("setCatalogName", this.selectedCatalogName);
      this.$emit("stepChange", {
        currentState: "ExistingCatalog",
        nextState: "CatalogOptions"
      });
    },

    selectCatalogId(catalog) {
      this.selectedCatalogId = catalog[this.language].catalogId;
      this.selectedCatalogName = this.getCatalogName(catalog);
    },
    getCatalogName: function (catalog) {
      const lang = this.primaryLanguage;
      const name = catalog[lang.languageCode].name;
      if (name) {
        return name;
      }

      if (lang.fallbackLanguageCode) {
        return catalog[lang.fallbackLanguageCode].name || "";
      }

      return "";
    }
  }
};
</script>
